import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const getLandingPathForRole = (role) => {
  const normalizedRole = String(role || "").toLowerCase();

  switch (normalizedRole) {
    case "control":
      return "/device-controls";
    case "technician":
      return "/my-services";
    case "customer":
      return "/driftsdashboard";
    case "admin":
    case "user":
    default:
      return "/";
  }
};

const getSafeNextPath = (nextPath) => {
  if (!nextPath) return null;
  if (!nextPath.startsWith("/")) return null;
  if (nextPath.startsWith("//")) return null;
  if (nextPath.startsWith("/login")) return null;
  return nextPath;
};

const PublicRoute = ({ children }) => {
  const { isAuth, user, loading } = useAuth();
  const location = useLocation();
  const nextParam = new URLSearchParams(location.search).get("next") || "";
  const safeNextPath = getSafeNextPath(nextParam);

  // While auth status is being determined
  if (loading) return null;

  // Redirect signed-in users based on their role, but preserve the original requested page
  if (isAuth && user) {
    if (safeNextPath) {
      return <Navigate to={safeNextPath} replace />;
    }

    return <Navigate to={getLandingPathForRole(user.role)} replace />;
  }

  return children;
};

export default PublicRoute;
